import { useState } from 'react';
import { Navigate, RouterProvider, createBrowserRouter, type RouteObject } from 'react-router';
import { Shell } from './components/shell';
import { Account } from './pages/account';
import { GuestEditor, GuestsList } from './pages/guests';
import { BandiPage } from './pages/bandi';
import { BookingPage } from './pages/booking';
import type { AdminConfig } from './config';
import { SessionProvider } from './lib/session';
import { EventEditor } from './pages/event-editor';
import { EventsList } from './pages/events-list';
import { Duplicates } from './pages/duplicates';
import { EventMerge } from './pages/event-merge';
import { CandidateDetail } from './pages/candidate-detail';
import { Reports } from './pages/reports';
import { ReviewList } from './pages/review-list';
import { RunDetail } from './pages/run-detail';
import { Places } from './pages/places';
import { RassegnaEditor } from './pages/rassegna-editor';
import { RassegneList } from './pages/rassegne';
import { Settings } from './pages/settings';
import { Stats } from './pages/stats';
import { Social } from './pages/social';
import { SurveyEditor } from './pages/survey-editor';
import { SurveysList } from './pages/surveys';
import { Sources } from './pages/sources';
import { Telegram } from './pages/telegram';
import { Users } from './pages/users';

const routes: RouteObject[] = [
  {
    element: <Shell />,
    children: [
      { index: true, element: <Navigate to="/events" replace /> },
      { path: 'events', element: <EventsList /> },
      { path: 'events/new', element: <EventEditor /> },
      { path: 'events/duplicates', element: <Duplicates /> },
      { path: 'events/merge', element: <EventMerge /> },
      { path: 'events/:id', element: <EventEditor /> },
      { path: 'review', element: <ReviewList /> },
      { path: 'review/:id', element: <CandidateDetail /> },
      { path: 'reports', element: <Reports /> },
      { path: 'sources', element: <Sources /> },
      { path: 'sources/runs/:id', element: <RunDetail /> },
      { path: 'settings', element: <Settings /> },
      { path: 'telegram', element: <Telegram /> },
      { path: 'users', element: <Users /> },
      { path: 'account', element: <Account /> },
      { path: 'social', element: <Social /> },
      { path: 'surveys', element: <SurveysList /> },
      { path: 'surveys/:id', element: <SurveyEditor /> },
      { path: 'places', element: <Places /> },
      { path: 'rassegne', element: <RassegneList /> },
      { path: 'rassegne/new', element: <RassegnaEditor /> },
      { path: 'rassegne/:slug', element: <RassegnaEditor /> },
      { path: 'stats', element: <Stats /> },
      { path: 'booking', element: <BookingPage /> },
      { path: 'bandi', element: <BandiPage /> },
      { path: 'guests', element: <GuestsList /> },
      { path: 'guests/new', element: <GuestEditor /> },
      { path: 'guests/:slug', element: <GuestEditor /> },
      { path: '*', element: <Navigate to="/events" replace /> },
    ],
  },
];

/** Il router si crea solo dopo l'accesso, e parte dall'indirizzo richiesto. */
function Routes() {
  const [router] = useState(() => createBrowserRouter(routes));
  return <RouterProvider router={router} />;
}

export function App({ config }: { config: AdminConfig }) {
  return (
    <SessionProvider config={config}>
      <Routes />
    </SessionProvider>
  );
}
